export default {
  nameIsRequired: 'Nome é necessário',
  emailIsRequired: 'E-mail é necessário',
  passwordIsRequired: 'Senha é necessária',
  emailOrPhoneAreRequired: 'Insira um e-mail ou telefone',
  onlyNumbers: 'Apenas números são permitidos no campo telefônico',
  passwordMin8: 'A senha deve ter pelo menos 8 caracteres',
  habeasData: 'Você deve aceitar os termos e condições do acordo',
  validEmail: 'Insira um e-mail válido',
  validPhone: 'Insira um telefone válido',
  codeIsRequired: 'O código enviado é necessário',
  newPasswordIsRequired: 'Nova senha é necessária',
  confirmNewPassword: 'Você deve confirmar sua nova senha',
  passwordsDontMatch: 'Senhas não combinam',
  fillCorrectlyFormFields: 'Preencha corretamente todos os campos de formulário'
}
